import React from 'react'
import RichText from '../../utils/RichText'
import Button from '../Button'

const SubmenuCta = (props) => {
    // Extra IF for when all of the content is deleted in the backend but there is empty data
    if (props.cta_content && props.cta_content.content[0]['content']) {
        return (
            <div className="bg-gray-50">
                <div className="max-w-[1440px] mx-auto space-y-6 lg:px-16 px-6 py-8 sm:flex justify-between align-center sm:space-y-0 sm:space-x-10">
                    <div className="prose text-xs max-w-md my-auto">
                        <RichText>{props.cta_content}</RichText>   
                    </div>
                    {props.cta_button_text && <Button target={`/${props.cta_button_target.cached_url}`} className="bg-red hover:bg-darkred lg:text-lg text-base">{props.cta_button_text}</Button>}
                </div>
            </div>
        )
    } else return null
};

export default SubmenuCta;
